'use client';

import classNames from '@sindresorhus/class-names';
import {HeaderProps} from '@ui-kit/src/Header/Header.types';
import {useEffect, useState} from 'react';

import {Anchors} from './components/Anchors';
import {Links} from './components/Links';
import {Logo} from './components/Logo';
import styles from './Header.module.scss';

export const Header = ({
  links,
  onLinkClick,
  onAnchorLinkClick,
  anchorLinks,
  logo,
  showLogoAlways,
  rightSideContent,
  mobileMenu,
  activeLinkOrder,
}: HeaderProps) => {
  const [isTopScroll, setTopScroll] = useState(true);
  const [isMobileMenuVisible, setMobileMenuVisible] = useState(false);
  useEffect(() => {
    const containerEl = document.createElement('img');
    containerEl.className = styles.hidedScrollImg;
    document.body.append(containerEl);

    const options: IntersectionObserverInit = {
      threshold: 1,
    };

    const intersectionObserver = new IntersectionObserver((entries) => {
      setTopScroll(entries[0].isIntersecting);
    }, options);

    intersectionObserver.observe(containerEl);
  }, []);

  return (
    <>
      <header className={styles.wrapper}>
        <div
          className={classNames(styles.headerWrapper, {
            [styles.scrollHeader]: !isTopScroll,
          })}
        >
          <div
            className={classNames(styles.header, {
              [styles.animPaddings]: isTopScroll,
            })}
          >
            <Logo
              logo={logo}
              topScroll={showLogoAlways || !isTopScroll}
              isMenuOpened={isMobileMenuVisible}
            />
            <Links
              activeLinkOrder={activeLinkOrder}
              isMobileMenuVisible={isMobileMenuVisible}
              setMobileMenuVisible={setMobileMenuVisible}
              links={links}
              onLinkClick={onLinkClick}
              mobileMenu={mobileMenu}
            />
            <div className={styles.rightSideContent}>
              {rightSideContent?.({isTopScroll})}
            </div>
          </div>
        </div>
        <Anchors
          anchorLinks={anchorLinks}
          onAnchorLinkClick={onAnchorLinkClick}
        />
      </header>
    </>
  );
};
